import React from 'react';
import { useTheme } from '@mui/material';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import { Button } from '../Button/Button';
import { ExportDialogRenderProps } from './ExportDialogRenderProps';
import { ExportMove16 } from '@weave-design/icons';
const ExportButtonWithDialogAndText = ({ disabled, iconProps, title, variant, iconDataCy = 'export-icon', dataCy, color, ...props }) => {
    const { t } = useGlobalization();
    const palette = useTheme().palette;
    const enabledColor = palette?.[color ?? 'primary']?.dark ?? palette?.primary?.dark;
    const disabledColor = enabledColor + '50';
    return (React.createElement(ExportDialogRenderProps, { ...props }, ({ handleOpenExport }) => (React.createElement(Button, { color: color ?? 'primary', variant: variant ?? 'text', onClick: handleOpenExport, "data-cy": dataCy, disabled: disabled, startIcon: React.createElement(ExportMove16, { "data-cy": iconDataCy, color: disabled ? disabledColor : enabledColor, ...iconProps }), ...props }, title ?? t('Export')))));
};
export default ExportButtonWithDialogAndText;
